var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216.827,
    height: 240.9,
    viewBox: "0 0 57.369 63.738",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.214 219.485h34.043v37.823h-34.043Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.68517 0 0 -1.68517 -1085.612 433.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.988 231.872h26.814l-13.407 22.571zm27.636-2.365h-28.458c-.767 0-1.396.333-1.726.914-.331.582-.297 1.293.095 1.951l14.202 23.912c.387.65.99 1.024 1.658 1.024.667 0 1.271-.373 1.658-1.024l14.202-23.912c.392-.658.426-1.369.095-1.95-.33-.582-.96-.915-1.726-.915",
    style: {
      fill: "#e42b2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.001 235.424c0-.58-.474-1.054-1.054-1.054h-.833c-.58 0-1.054.474-1.054 1.054v.47c0 .58.474 1.055 1.054 1.055h.833c.58 0 1.054-.475 1.054-1.054zm0 4.453c0-.58-.474-1.054-1.054-1.054h-.833c-.58 0-1.054.474-1.054 1.054v7.5c0 .58.474 1.054 1.054 1.054h.833c.58 0 1.054-.474 1.054-1.054z",
    style: {
      fill: "#e42b2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m661.687 226.57-.199.336c-.429.729-.841 1.467-1.29 2.183-.737 1.178-1.54 2.307-2.46 3.357-.375.43-.765.769-1.33.867-.228.04-.463.047-.695.06-.847.047-1.67-.047-2.425-.467-.412-.23-.555-.51-.44-.88.052-.169.164-.332.285-.465a21.288 21.288 0 0 0 2.999-4.224c1.195-2.214 2.327-4.462 3.479-6.7.168-.325.396-.576.726-.726 1.071-.486 2.174-.56 3.294-.202.447.143.754.44.913.905.443 1.295.882 2.593 1.371 3.87a93.32 93.32 0 0 0 5.234 11.314 116.74 116.74 0 0 0 1.825 3.221 95.803 95.803 0 0 0 5.071 7.758c.372.512.24.892-.274 1.151-.095.048-.19.098-.29.134-.841.302-1.704.355-2.587.249-.802-.097-1.402-.455-1.854-1.153-1.086-1.68-2.254-3.31-3.327-4.998a96.044 96.044 0 0 1-7.356-13.998c-.216-.507-.428-1.016-.67-1.592",
    style: {
      fill: "#009149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.687 226.57c.242.576.454 1.085.67 1.592a96.044 96.044 0 0 0 7.356 13.997c1.073 1.69 2.24 3.318 3.327 5 .452.697 1.053 1.055 1.854 1.152.883.106 1.746.053 2.586-.25.1-.036.196-.085.291-.133.514-.259.646-.64.274-1.15a95.803 95.803 0 0 1-5.071-7.759 116.74 116.74 0 0 1-1.825-3.221 93.32 93.32 0 0 1-5.234-11.314c-.49-1.277-.927-2.575-1.37-3.87-.16-.465-.467-.762-.914-.905-1.12-.358-2.223-.284-3.294.202-.33.15-.558.4-.726.727-1.152 2.237-2.284 4.485-3.48 6.7a21.288 21.288 0 0 1-2.997 4.223 1.296 1.296 0 0 0-.286.465c-.114.37.029.65.44.88.754.42 1.578.514 2.425.467.232-.013.467-.02.695-.06.565-.098.955-.437 1.33-.867.92-1.05 1.723-2.179 2.46-3.357.449-.716.862-1.455 1.29-2.183l.199-.336",
    style: {
      fill: "#009149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.385 236.712-.152-.087c.05.03.101.058.152.087",
    style: {
      fill: "#b22e4c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskManagement);
export default __webpack_public_path__ + "static/media/risk_management.3c8b02b077d6a0456a1b92063403a054.svg";
export { ForwardRef as ReactComponent };